'use client'

import { LazyMotion } from 'framer-motion'

// Animation features are fetched after hydration instead of shipping in the initial bundle
const loadFeatures = () => import('./motion-features').then(mod => mod.default)

export default function MotionProvider({ children }: { children: React.ReactNode }) {
  return (
    <LazyMotion features={loadFeatures} strict>
      {children}
    </LazyMotion>
  )
}
